import { render, staticRenderFns } from "./VideoPanel.vue?vue&type=template&id=70a8b6fa"
import script from "./VideoPanel.vue?vue&type=script&lang=js"
export * from "./VideoPanel.vue?vue&type=script&lang=js"
import style0 from "./VideoPanel.vue?vue&type=style&index=0&id=70a8b6fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports